import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  createMSSReportQueue: {},
  redirectLink: '',
  allMSSReportQueue: [{}],
  mssReportQueue: [],
  downloadMSSReportQueue: {},
  error: [],
  customerReportQueue: [],
  toggleMSSReportModal: false,
  isCustomerReportLoading: false,
  isLoading: false,
};

const mssReportQueueSlice = createSlice({
  name: 'mssReportQueue',
  initialState,
  reducers: {
    start: (state) => {
      state.error = [];
      state.isLoading = true;
    },
    getCustomerReportStart: (state) => {
      state.isCustomerReportLoading = true;
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isCustomerReportLoading = false;
    },
    setCreateMSSReportQueue: (state, action) => {
      state.createMSSReportQueue = action.payload;
      state.isLoading = false;
    },
    setRedirectLink: (state, action) => {
      state.redirectLink = action.payload;
      state.isLoading = false;
    },
    setAllCustomerReportQueue: (state, action) => {
      state.customerReportQueue = action.payload;
      state.isLoading = false;
    },
    setCustomerReportQueue: (state, action) => {
      state.customerReportQueue = action.payload;
      state.isCustomerReportLoading = false;
      state.error = [];
    },
    setDownloadMSSReportQueue: (state, action) => {
      state.downloadMSSReportQueue = action.payload;
      state.isLoading = false;
    },
    setToggleMSSReportModal: (state) => {
      state.toggleMSSReportModal = !state.toggleMSSReportModal;
    },
    setResetMssReport: () => {
      return initialState;
    },
  },
});

export const {
  start,
  getCustomerReportStart,
  setReducerError,
  setCreateMSSReportQueue,
  setRedirectLink,
  setAllCustomerReportQueue,
  setCustomerReportQueue,
  setDownloadMSSReportQueue,
  setToggleMSSReportModal,
  setResetMssReport,
} = mssReportQueueSlice.actions;

export default mssReportQueueSlice.reducer;
